<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { deviceDetails } from "./stores/deviceDetails";
  import GetDeliveryButton from "./GetDeliveryButton.svelte";

  // Get the block data
  export let blok;

  // Get the device type
  $: ({ isMobile, isTablet, isDesktop } = $deviceDetails);

  // Set the background image based on the device type
  $: backgroundImage =
    isMobile || isTablet ? blok.imageMobile?.filename : blok.imageDesktop?.filename;
</script>

<section
  class="hero-image-section mx-auto"
  style="background-image: url({backgroundImage});"
  use:storyblokEditable={blok}
>
  <div class="content-wrapper">
    <h1 class="main-heading">{blok.heading}</h1>
    <h2 class="main-subheading">{blok.subheading}</h2>
    <GetDeliveryButton {blok} />
  </div>
</section>

<style lang="postcss">
  .hero-image-section {
    position: relative;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    aspect-ratio: 3 / 6;

    @screen lg {
      aspect-ratio: 16 / 12;
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    padding-top: 210px;

    @screen md {
      padding-top: 28vh;
    }
  }

  .main-heading {
    font-size: 50px;
    font-family: var(--font-secondary);
    font-weight: var(--font-weight-semibold);
    line-height: 1.1;
    color: #fff;
    white-space: pre-wrap;
    text-align: center;

    @screen md {
      font-size: 72px;
    }

    @screen lg {
      font-size: 88px;
    }
  }

  .main-subheading {
    margin-top: 1rem;
    font-size: 16px;
    line-height: 1.6;
    font-weight: 300;
    color: #fff;
    white-space: pre-wrap;

    @screen md {
      margin-top: 0;
      font-size: 20px;
    }
  }

  :global(.get-delivery-button-wrapper) {
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;

    @screen lg {
      margin-top: 2rem;
    }
  }
</style>
